export const viewModes = {
  PROJECTION: 'PROJECTION',
  CLASSICAL: 'CLASSICAL',
  SELFSTUDY: 'SELFSTUDY',
  MULTISCREEN: 'MULTISCREEN',
};
